// middleware/auth.js
import {useAuthStore} from "~/stores/auth/index.js";

export default defineNuxtRouteMiddleware((to, from) => {
    const authStore = useAuthStore()

    // Définir les permissions requises par route
    const routePermissions = {
        '/admin': [],
        '/admin/profile': [],
        '/admin/users': ['user_read','user_create','user_update','user_manage','manage_all'],
        '/admin/roles': ['role_read','role_create','role_update','role_manage','manage_all'],
        '/admin/contact-requests': ['quote_read','quote_answer','quote_update','quote_manage','manage_all'],
    }

    // Vérifier si l'utilisateur est authentifié
    if (!authStore.isAuthenticated) {
        return navigateTo('/auth/login')
    }

    // Récupérer les permissions requises pour cette route
    const requiredPermissions = getRequiredPermissions(to.path, routePermissions)

    if (requiredPermissions.length > 0) {
        // Vérifier si l'utilisateur a les permissions nécessaires
        const userPermissions = authStore.user?.role?.permissions || []
        console.log(userPermissions)
        const hasPermission = requiredPermissions.some(perm =>
            userPermissions[perm]
        )

        if (!hasPermission) {
            console.log('permissions')
            // Créer une erreur 401 avec les détails
            throw createError({
                statusCode: 401,
                statusMessage: 'Unauthorized Access',
                data: {
                    requiredPermissions,
                    requestedPath: to.path,
                    userPermissions
                }
            })
        }
    }
})

// Fonction helper pour obtenir les permissions requises
function getRequiredPermissions(path, routePermissions) {
    // Vérification exacte
    if (routePermissions[path]) {
        return routePermissions[path]
    }

    // Vérification par préfixe (pour les routes imbriquées)
    for (const [route, permissions] of Object.entries(routePermissions)) {
        if (path.startsWith(route)) {
            return permissions
        }
    }

    return []
}